import request from '@/utils/request'

let Stage_stageApi = {
    getJzList(data) {
    return request._post('/shop/plus.stage_stage.Index/getdatestage', data);
},


  /*阶段列表*/
  list(data) {
    return request._post('/shop/plus.stage_stage.Index/index', data);
},
/*添加阶段*/
add(data) {
    return request._post('/shop/plus.stage_stage.Index/add', data);
},
/*修改阶段*/
edit(data) {
    return request._post('/shop/plus.stage_stage.Index/edit', data);
},
/*删除阶段*/
del(data) {
    return request._post('/shop/plus.stage_stage.Index/del', data);
},
/*阶段详情*/
detail(data) {
  return request._post('/shop/plus.stage_stage.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.stage_stage.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.stage_stage.Setting/getSetting', data, errorback);
    },
}
export default Stage_stageApi;



// WEBPACK FOOTER //
// ./src/api/stage_stage.js